import { withExperiments } from '@wix/wix-experiments-react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { BackButton } from 'components/BackButton/AdvancedPlans/BackButton';
import { SaleBanner } from './SaleBanner/SaleBanner';
import { AppTitleProps } from './AppTitleProps';
import { AppSubtitleAnimated } from './AppSubtitle';
import style from './AppTitle.scss';
import { Title } from './Title';
import { Experiments, PlanType } from 'enums';
import { useAppTitles } from './useAppTitles';

const plansPageStep = 0;

const AdvancedPlansTitleComp: React.FC<AppTitleProps> = ({
  rootStore: { appStore },
  experiments,
}) => {
  const { t } = useTranslation();
  const { theme: themeName } = usePageModeContext();
  const { appTitle } = useAppTitles(appStore);

  const {
    handleOnBackButtonClick,
    currentStep,
    isInSale,
    isWizardHidden,
    isChangePlanToastMode,
    planType,
    shouldStoreIntentNoTabs,
    isJapanesePackagePicker,
    isDowngradePlanOfDeclineChargeService,
  } = appStore;
  const isEnterpriseTab =
    experiments.enabled(Experiments.AddEnterpriseTab) &&
    planType === PlanType.Enterprise;
  const topTitle = isJapanesePackagePicker;
  return (
    <div
      className={classNames(
        style.headerContainer,
        {
          [style.saleTitle]: isInSale,
          [style.changePlanBar]: isChangePlanToastMode,
          [style.noTabsSpec]:
            shouldStoreIntentNoTabs && currentStep === plansPageStep,
        },
        style.newTabs,
        themeName,
      )}
    >
      <div className={classNames(style.titleContainer, themeName)}>
        <div
          data-hook='sale-banner-container'
          className={classNames(style.saleBannerContainer, {
            [style.hidden]: isEnterpriseTab,
          })}
        >
          {isInSale && <SaleBanner />}
        </div>
        <div
          className={classNames(style.mainTitle, themeName, {
            [style.reverse]: topTitle,
          })}
        >
          {!isWizardHidden && (
            <BackButton
              handleOnBackButtonClick={handleOnBackButtonClick}
              currentStep={currentStep}
              isSecondStepDisabled={isDowngradePlanOfDeclineChargeService}
            />
          )}
          <Title titleText={t(appTitle)} />
          <AppSubtitleAnimated />
        </div>
      </div>
    </div>
  );
};

export const AdvancedPlansTitle = withInjectedRootStore(
  withExperiments(observer(AdvancedPlansTitleComp)),
);
